import format from './format'
// const moment = require('moment')

const DAY_MILLISECONDS = 86400000
const MS_DAY_OFFSET = 25569

const oaDateToTicks = oaDate => {
    return ((oaDate - MS_DAY_OFFSET) * DAY_MILLISECONDS) + (oaDate >= 0.0 ? 0.5 : -0.5)
}

export const msDateToDateFormat = (oaDate, timezone) => {
    let offset = 0
    const offsetAEDT = format.getAUTimeZoneAbbrName(oaDate) === 'AEDT' ? 1 : 0
    if (timezone === 'EST') {
        offset = 15 + offsetAEDT
    } else if (timezone === 'GMT') {
        offset = 10 + offsetAEDT
    }

    const ticks = oaDateToTicks(oaDate)
    // adding offset since chart call only return date in TZ format,
    // for all timezones without adjusting hours
    let newDate = new Date(ticks)
    newDate.setHours(newDate.getHours() + offset)
    newDate = newDate.toISOString()
    return format.formatDateFromDateTime(newDate, null, true)
}
